import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createCustomSurveyFromTemplate,
  CreateCustomSurveyFromTemplateRequest,
  CustomSurveyResponse,
} from '../../api/customSurveys';
import { customSurveyKeys } from '../queries/queryKeys';

type UseCreateCustomSurveyMutationOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useCreateCustomSurveyMutation = (
  teamId: number,
  options?: UseCreateCustomSurveyMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    CustomSurveyResponse,
    Error,
    Omit<CreateCustomSurveyFromTemplateRequest, 'teamId'>
  >({
    mutationFn: (data) =>
      createCustomSurveyFromTemplate({
        ...data,
        teamId,
      }),
    onSuccess: (...args) => {
      // Invalidate surveys list for this team
      queryClient.invalidateQueries({ queryKey: customSurveyKeys.byTeam(teamId) });
      // Invalidate all surveys lists
      queryClient.invalidateQueries({ queryKey: customSurveyKeys.lists() });
      options?.onSuccess?.(...args);
    },
    onError: options?.onError,
  });
};
